<template>
	<div class="ibox float-e-margins ibox-content" style="position: relative; height: 100%;" id="deviceDirectiveEdit">
		<div class="form-horizontal">
			<div class="form-group">
				<label class="col-sm-1 control-label">指令名称</label>
				<div class="col-sm-5">
					<input type="text" class="form-control" v-model="editItem.cmdName" v-bind:readonly="mode=='check'">
				</div>
				<label class="col-sm-1 control-label">指令类型</label>
				<div class="col-sm-5">
					<select class="form-control" v-model="editItem.cmdType" v-bind:disabled="mode=='check'">
						<option v-for="option in cmdTypes" v-bind:value="option.udccode">
							{{ option.udcname }}
						</option>
					</select>
				</div>
			</div>
			<div class="form-group">
				<label class="col-sm-1 control-label">创建时间</label>
				<div class="col-sm-5">
					<input type="text" class="form-control" v-model="editItem.createTime" readonly>
				</div>
				<label class="col-sm-1 control-label">修改时间</label>
				<div class="col-sm-5">
					<input type="text" class="form-control" v-model="editItem.updateTime" readonly>
				</div>
			</div>

			<div class="form-group">
				<div class="col-sm-12 text-center">
					<button v-show="mode!=='check'" class="btn btn-primary" @click="update"  :disabled="editItem.cmdName==''">确定</button>
					<button class="btn btn-primary" @click="close">关闭</button>
				</div>
			</div>

		</div>
		<sub-modal ref="modalMsg" size="small" title="提示">
			{{tipContent}}
			<div slot="footer">
				<button class="btn btn-primary" @click="closeMsgTip">确定</button>
			</div>
		</sub-modal>

	</div>

</template>

<script>
	import SubModal from 'components/common/SubModal'
	import { OPERATE_SUCCESS, OPERATE_EXCEPTION } from 'static/message'
	import classlist from 'util/classlist'
	export default {
		name: "PageDeviceDirectiveEdit",
		components: {
			SubModal
		},
		props: [ "cmdTypes", "mode"],
		data() {
			return {
				tipContent: '11',
				scrollTop: '',	
				editItem:{
					cmdName:'',
					cmdType:'',
					id:'',
					createTime:'',
					updateTime:''	
				}
			}
		},
		
		methods: {
			close(action) {
				this.$emit('toClose', action);
			},	
			
			setEditItem(item){
				this.editItem.cmdName = item.cmdName;
				this.editItem.cmdType = item.cmdType;
				this.editItem.id = item.id;
				this.editItem.createTime=item.createTime;
				this.editItem.updateTime = item.updateTime;
			},
			
			
			update() {
				if(this.editItem.cmdName==''){
					this.openMsgTip('指令名称不能为空');
					return ;
				}
					
				if(this.mode == 'edit') {
					this.$http.put(process.env.API_ROOT + '/system/cmd/' + this.editItem.id, this.editItem)
						.then(res => {
								if(!res.data.success) {
									this.openMsgTip(res.data.message)
								} else
									this.close('refresh');
							},
							res => {
								this.openMsgTip(res.data.message);
							}
						)
						.catch(res => {
							this.openMsgTip(OPERATE_EXCEPTION);
						})
				}
				if(this.mode == 'create') {		
					this.$http.post(process.env.API_ROOT + '/system/cmd/', this.editItem)
						.then(res => {
								if(!res.data.success) {
									this.openMsgTip(res.data.message)
								} else
									this.close('refresh');
							},
							res => {
								this.openMsgTip(res.data.message);
							}
						)
						.catch(res => {
							this.openMsgTip(res.data.message);
						})
				}

			},
			// 消息弹出框相关 
			closeMsgTip() {
				this.$refs.modalMsg.close();
			},
			openMsgTip(message) {
				this.tipContent = message
				this.$refs.modalMsg.open();
				classlist.toggleScroll('close', '#deviceDirectiveEdit', this);
			}

		}
	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// PageDeviceDirectiveEdit.vue?325249e0